import operatorApiFetch from './apiService';

const bundleService = {
  // 獲取組合包列表（用於下拉搜尋）
  fetchList: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.merchant_id) queryParams.append('merchant_id', params.merchant_id);

    const res = await operatorApiFetch(`bundles?${queryParams.toString()}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 獲取組合包列表（用於表格）
  getRecords: async (params = {}) => {
    const res = await operatorApiFetch('bundles/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取所有組合包 ID（用於篩選）
  getIds: async (params = {}) => {
    const res = await operatorApiFetch('bundles/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取單個組合包
  get: async (id) => {
    const res = await operatorApiFetch(`bundles/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 創建組合包
  create: async (data) => {
    const res = await operatorApiFetch('bundles', {
      method: 'POST',
      body: { bundle: data }
    });
    return res.json();
  },

  // 更新組合包
  update: async (id, data) => {
    const res = await operatorApiFetch(`bundles/${id}`, {
      method: 'PUT',
      body: { bundle: data }
    });
    return res.json();
  },

  // 刪除組合包（軟刪除）
  delete: async (id) => {
    const res = await operatorApiFetch(`bundles/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  },

  // 匯出組合包
  export: async (ids) => {
    const res = await operatorApiFetch('bundles/export', {
      method: 'POST',
      body: { ids }
    });
    return res.json();
  },

  // 匯入組合包
  import: async (formData) => {
    const res = await operatorApiFetch('bundles/import', {
      method: 'POST',
      body: formData
    });
    return res.json();
  },

  // 下載匯入模板
  downloadImportTemplate: async (locale, merchantId) => {
    const body = { type: 'bundle', locale };
    if (merchantId) {
      body.merchant_id = merchantId;
    }
    return operatorApiFetch('import_templates/download', {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  }
};

export { bundleService };
export default bundleService;
